export function createNewRow() {
    return (
        window['headerPanel'] &&
        window['headerPanel'].createNewRow &&
        window['headerPanel'].createNewRow()
    );
}

export function togglePageClass(value: boolean) {
    window['headerPanel'] &&
        window['headerPanel'].togglePageClass &&
        window['headerPanel'].togglePageClass(value);
}
